<template>
  <el-form class="w-100" :model="mainItem" :ref="'form'" :rules="rules" label-width="120px"
           size="mini">
    <!--    开票信息-->
    <div style="padding-bottom: 16px;" class="d-flex-row justify-content-between">
      <div class="invoiceTitle">
        <div style="display: flex;">
          <div class="card-title invoice-title">开票信息&emsp;&emsp;</div>
          <div style="margin-left: 20px">客户名称： {{ mainItem.customer_name }}</div>
          <div style="margin-left: 10px">发票总收款：{{ moneyFormat(mainItem.payment_account || 0) }} &nbsp;</div>
          <div style="margin-left: 10px">发票剩余金额：{{ moneyFormat(mainItem.invoice_money_surplus) }} &nbsp;</div>
        </div>
      </div>
      <div>
        <el-link type="primary" @click="cpInvoice()" icon="el-icon-circle-plus-outline">添加发票</el-link>
      </div>
    </div>
    <div v-for="(item, cIndex) in mainItem.children" class="bill-border" :key="cIndex">
      <i v-if="cIndex" class="el-icon-error invoice-delete" @click="delInvoice(cIndex)"/>
      <template>
        <div style="margin-bottom: 10px;display: flex">
          <div>
            <b>基础信息</b>&nbsp;
            <el-link type="primary" title="修改客户的发票信息"
                     @click="editCustomer(mainItem.customer_id,mainItem.sale_id)">
              <i class="el-icon-edit-outline"></i>
            </el-link>
            &nbsp;
            <el-link type="primary" icon="el-icon-refresh" @click="reloadInvoiceInfo(cIndex)"
                     title="加载【默认发票信息】"></el-link>
          </div>
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="发票抬头" :prop="'children.' + cIndex + '.invoice_title'" :rules="rules.invoice_title">
              <el-input
                  v-model="item.invoice_title"
                  placeholder="请输入发票抬头"
                  maxlength="128"
                  show-word-limit
                  clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="税号" :prop="'children.' + cIndex + '.tax_id'" :rules="rules.tax_id">
              <el-input
                  v-model="item.tax_id"
                  placeholder="请输入税号"
                  maxlength="64"
                  show-word-limit
                  clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="发票金额" :prop="'children.' + cIndex + '.amount_money'" :rules="rules.amount_money">
              <el-input
                  v-model="item.amount_money"
                  placeholder="请输入发票金额"
                  oninput="value=value.replace(/[^\d^\.^\-]/g,'')"
                  @change="amountMoneyChange(cIndex)"
                  clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票类型" :prop="'children.' + cIndex + '.type'" :rules="rules.type">
              <el-select v-model="item.type" placeholder="请选择发票类型" clearable style="width:100%">
                <el-option label="电子专票" value="spe_invoice"></el-option>
                <el-option label="电子普票" value="common_invoice"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开户行" :prop="'children.' + cIndex + '.bank_name'" :rules="rules.bank_name">
              <el-input
                  v-model="item.bank_name"
                  placeholder="请输入开户行"
                  maxlength="128"
                  show-word-limit
                  clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行卡号" :prop="'children.' + cIndex + '.bank_amount'" :rules="rules.bank_amount">
              <el-input
                  v-model="item.bank_amount"
                  placeholder="请输入银行卡号"
                  maxlength="64"
                  show-word-limit
                  clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="发票内容" :prop="'children.' + cIndex + '.content'" :rules="rules.content">
              <el-select v-model="item.content" placeholder="请选择发票内容" clearable style="width:100%">
                <el-option
                    v-for="(val, key) in invoiceContentOptions"
                    :key="key"
                    :label="val.value" :value="val.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户电话" :prop="'children.' + cIndex + '.telephone'" :rules="rules.telephone">
              <el-input
                  v-model="item.telephone"
                  placeholder="请输入客户电话"
                  maxlength="32"
                  show-word-limit
                  clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="详细地址" :prop="'children.' + cIndex + '.address'" :rules="rules.address">
              <el-input
                  v-model="item.address"
                  placeholder="请输入详细地址"
                  maxlength="128"
                  show-word-limit
                  clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
                label="备注"
            >
              <el-input
                  v-model="item.remark"
                  placeholder="请输入备注"
                  maxlength="128"
                  show-word-limit
                  clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <div style="margin-bottom: 10px"><b>接收方式</b></div>

        <el-row>

          <el-col :span="8">
            <el-form-item label="电子邮箱" :prop="'children.' + cIndex + '.contact_email'" :rules="rules.contact_email">
              <el-input
                  v-model="item.contact_email"
                  placeholder="请输入电子邮箱"
                  maxlength="32"
                  show-word-limit
                  clearable
              />
            </el-form-item>
          </el-col>
          <template v-if="item.type !== 'common_invoice'">
            <el-col :span="8">
              <el-form-item label="收件人" :prop="'children.' + cIndex + '.contact_name'" :rules="rules.contact_name">
                <el-input
                    v-model="item.contact_name"
                    placeholder="请输入收件人"
                    maxlength="32"
                    show-word-limit
                    clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系电话" :prop="'children.' + cIndex + '.contact_phone'"
                            :rules="rules.contact_phone">
                <el-input
                    v-model="item.contact_phone"
                    placeholder="请输入联系电话"
                    maxlength="32"
                    show-word-limit
                    clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="详细地址" :prop="'children.' + cIndex + '.contact_address'"
                            :rules="rules.contact_address">
                <el-input
                    v-model="item.contact_address"
                    placeholder="请输入详细地址"
                    maxlength="128"
                    show-word-limit
                    clearable
                />
              </el-form-item>
            </el-col>
          </template>
        </el-row>
        <div style="margin-bottom: 10px;display:flex;align-items:center;justify-content:space-between;">
          <div><b>订单信息</b></div>
          <div class="order-money-toolbar">
            <span>发票金额：{{ moneyFormat(item.amount_money || 0) }}</span>
            <span :class="orderMoneyDiff(item) === 0 ? 'money-matched' : 'money-unmatched'">
              已分配：{{ moneyFormat(orderMoneyAllocated(item)) }}
              （差额：{{ moneyFormat(orderMoneyDiff(item)) }}）
            </span>
            <el-link type="primary" icon="el-icon-s-grid" @click="distributeOrderMoney(item)">按剩余占比分配</el-link>
          </div>
        </div>
        <div style="margin-bottom: 10px">
          <el-form-item label="">
            <div class="default-table">
              <el-table :data="item.orders" show-summary :summary-method="(param) => getOrderSummaries(param, item)">
                <el-table-column label="订单编号" prop="order_no"/>
                <el-table-column label="含税收入" prop="payment_account" align="right">
                  <template v-slot="{row:{payment_account}}">
                    {{ payment_account |numberFormat(2) }}
                  </template>
                </el-table-column>
                <el-table-column label="已开票金额" prop="invoice_money_done" align="right">
                  <template v-slot="{row:{invoice_money_done}}">
                    {{ invoice_money_done |numberFormat(2) }}
                  </template>
                </el-table-column>
                <el-table-column label="申请中金额" prop="invoice_money_occupy" align="right">
                  <template v-slot="{row:{invoice_money_occupy}}">
                    {{ invoice_money_occupy |numberFormat(2) }}
                  </template>
                </el-table-column>
                <el-table-column label="剩余金额" prop="invoice_money_surplus" align="right">
                  <template v-slot="{row:{invoice_money_surplus}}">
                    {{ invoice_money_surplus |numberFormat(2) }}
                  </template>
                </el-table-column>
                <el-table-column label="开票金额" prop="invoice_money" width="150" align="right">
                  <template v-slot="{row}">
                    <el-input
                        v-model="row.invoice_money"
                        size="mini"
                        placeholder="请输入"
                        oninput="value=value.replace(/[^\d^\.^\-]/g,'')"
                        @change="orderMoneyInput(row)"
                    />
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
        </div>
      </template>
    </div>
  </el-form>
</template>

<script>
import {getByCustomerSaleId} from "@/api/customers";
import {getSaleCustomerInvoiceInfo} from "@/api/bill";
import {splitAmountByRatio} from "./invoiceMoneyAlloc";

const rules = {
  invoice_title: [{required: true, message: "请输入发票抬头", trigger: "blur"}],
  amount_money: [{required: true, message: "请输入发票金额", trigger: "blur"}],
  tax_id: [{required: true, message: "请输入税号", trigger: "change"}],
  content: [{required: true, message: "请选择发票内容", trigger: "change"}],
  type: [{required: true, message: "请选择发票类型", trigger: "change"}],
  pay_term: [{required: true, message: "请选择付款方式", trigger: "change"}],
  transfer_time: [{required: true, message: "请选择结款时间", trigger: "change"}],
  contact_email: [
    {required: true, message: '请输入邮箱地址', trigger: 'blur'},
    {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}
  ],
};
export default {
  name: "CustomerInvoiceTemp",
  components: {},
  props: {
    mainItem: {
      type: Object,
      default() {
        return {}
      }
    },
    invoiceContentOptions: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      rules
    }
  },
  methods: {
    moneyFormat(value) { // 金额 格式化
      return this.gFunc.numberFormat(value, 2, '.', ',')
    },
    async editCustomer(customer_id, sale_id) {

      let {id} = await getByCustomerSaleId({customer_id: customer_id, sale_id: sale_id}).then(res => {
        return res.model
      })
      // this.$notify.success(`customer_id:${customer_id},sale_id:${sale_id},id:${id}`)
      if (id) {
        const {href} = this.$router.resolve({
          name: `editCustom`,
          params: {id: id}//customer_id: row.customer_id, sale_id: row.sale_id
        });
        window.open(href, "_blank");
      }

    },
    // 复制发票
    cpInvoice() {
      const obj = JSON.parse(JSON.stringify(this.mainItem.children[0]));
      this.mainItem.children.push(obj);
    },
    // 删除发票
    delInvoice(cIndex) {
      this.mainItem.children.splice(cIndex, 1);
      // this.invoiceMoneyChange(index)
    },
    // 计算单张发票下各订单已分配的开票金额合计
    orderMoneyAllocated(item) {
      return (item.orders || []).reduce((sum, order) => {
        return sum.plus(order.invoice_money || 0)
      }, this.$bigNumber(0)).toNumber()
    },
    // 已分配金额与发票金额的差额
    orderMoneyDiff(item) {
      return this.$bigNumber(this.orderMoneyAllocated(item)).minus(item.amount_money || 0).toNumber()
    },
    // 按各订单剩余金额占比，将发票金额分配到各订单（不超过各自剩余金额）
    distributeOrderMoney(item) {
      const orders = item.orders || []
      const amounts = splitAmountByRatio(orders.map(order => order.invoice_money_surplus || 0), item.amount_money)
      orders.forEach((order, index) => {
        order.invoice_money = amounts[index] || '0.00'
      })
    },
    // 发票金额变更后，按剩余占比重新分配
    amountMoneyChange(cIndex) {
      this.distributeOrderMoney(this.mainItem.children[cIndex])
    },
    // 手动输入单个订单开票金额后，规范为 2 位小数
    orderMoneyInput(row) {
      const val = row.invoice_money
      const num = this.$bigNumber(val === '' || val === null || val === undefined ? 0 : val)
      row.invoice_money = num.isNaN() ? '0.00' : num.toFixed(2)
    },
    // 订单信息表-表尾汇总（含各金额列合计：含税收入/已开票/申请中/剩余金额/开票金额）
    getOrderSummaries({columns}, item) {
      const moneyProps = ['payment_account', 'invoice_money_done', 'invoice_money_occupy', 'invoice_money_surplus', 'invoice_money']
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
        } else if (moneyProps.indexOf(column.property) > -1) {
          const total = (item.orders || []).reduce((sum, order) => {
            return sum.plus(order[column.property] || 0)
          }, this.$bigNumber(0))
          sums[index] = this.moneyFormat(total.toNumber())
        } else {
          sums[index] = ''
        }
      })
      return sums
    },

    async reloadInvoiceInfo(cIndex) {
      let {info, contact} = await getSaleCustomerInvoiceInfo({
        customer_id: this.mainItem.customer_id,
        sale_id: this.mainItem.sale_id
      }).then(res => {
        return res.model;
      })

      //基础信息
      this.mainItem.children[cIndex].customer_name = info.customer_name;
      this.mainItem.children[cIndex].customer_id = info.customer_id;
      this.mainItem.children[cIndex].invoice_title = info.invoice_title;
      this.mainItem.children[cIndex].tax_id = info.tax_id;//税号
      this.mainItem.children[cIndex].address = `${info.province||''}${info.city||''}${info.area||''}${info.address||''}`;
      this.mainItem.children[cIndex].telephone = info.telephone;
      this.mainItem.children[cIndex].bank_name = info.bank_name;
      this.mainItem.children[cIndex].bank_amount = info.bank_amount;
      this.mainItem.children[cIndex].type = info.invoice_type;
      //接收方式
      this.mainItem.children[cIndex].contact_name = contact.contact_name;
      this.mainItem.children[cIndex].contact_phone = contact.contact_phone;
      this.mainItem.children[cIndex].contact_email = info.invoice_email;
      this.mainItem.children[cIndex].contact_address = `${contact.contact_province||''}${contact.contact_city||''}${contact.contact_area||''}${contact.contact_address||''}`;

      if (Array.isArray(this.invoiceContentOptions)) {
        const hasValue = this.invoiceContentOptions.some(tmp => tmp.value === info.invoice_content);
        this.mainItem.children[cIndex].content = hasValue ? info.invoice_content : null;//发票内容
      } else {
        this.mainItem.children[cIndex].content = null;//发票内容
      }
    },

    validateForm() {
      let val = true;
      this.$refs.form.validate((v) => {
        if (!v) {
          val = v
        }
      })
      return val
    }
  },
}
</script>

<style scoped>
.invoiceTitle {
    margin-top: 20px;
}

.invoiceTitle:first-child {
    margin-top: 0;
}

.bill-border {
    margin-bottom: 24px;
    border: 1px solid #ebeef5;
    padding: 24px;
    position: relative;
}

.invoice-delete {
    cursor: pointer;
    font-size: 28px;
    position: absolute;
    top: -10px;
    right: -10px;
    color: rgba(46, 46, 46, 0.67);
}

.order-money-toolbar {
    display: flex;
    align-items: center;
}

.order-money-toolbar > span {
    margin-right: 16px;
}

.money-matched {
    color: #67c23a;
}

.money-unmatched {
    color: #f56c6c;
}
</style>
